export const SMALL_SCREEN_WIDTH = 530;
